// extracted by mini-css-extract-plugin
export var blackBgShape = "gradients-module--black-bg-shape--6f8bd";
export var gradientDarkBlue = "gradients-module--gradient-dark-blue--19e7c";
export var gradientLightPink = "gradients-module--gradient-light-pink--77994";
export var gradientPinkBottomTop = "gradients-module--gradient-pink-bottom-top--a1b74";
export var gradientText = "gradients-module--gradient-text--2ef73";